export class Benefits {
  PlanCode;
  CDesc;
  EDesc;
  StaffGrades;
  constructor() {
    this.PlanCode = "";
    this.CDesc = "";
    this.EDesc = "";
    this.StaffGrades = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/Benefits.js